import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import {
  ButtonContainer,
  ButtonItem,
  RadioItem,
  FormUnit,
  FormUnitRow,
  FormUnitCell,
} from "@/components/modules";
import { GeoMap } from "@/geoMap/GeoMap";
import { ref, withDefaults, watch } from "vue";
import { CommonView } from "../common/CommonView";
import { Feature } from "ol";
import { ExportUtil } from "@/attribute/convert/util/ExportUtil";
import { MessageDefine } from "../common/MessageDefine";
import { ServerError } from "@/geoMap/define/ServerError";
import { MultipleLayerError } from "@/geoMap/define/MultipleLayerError";
import { UnexportableLayerError } from "@/geoMap/define/UnexportableLayerError";
import { ISideMenuState } from "./ISideMenuState.ts"

/**
 * propsプロパティ定義
 */
interface Props {
  geoMap: GeoMap;
  commonView: CommonView;
  isOpen: boolean;
  zoomLevel: number;
  sideMenuState: ISideMenuState;
}
enum ExportFormatList {
  CSV = "CSV",
  GeoJSON = "GeoJSON",
}

/**
 * 出力フォーマット状態
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'export-area',
  props: {
    geoMap: {},
    commonView: {},
    isOpen: { type: Boolean },
    zoomLevel: {},
    sideMenuState: {}
  },
  emits: ["endExportArea"],
  setup(__props: any, { emit }) {

const props = __props;




/**
 * 出力フォーマット定義
 */
const exportFormat = ref(ExportFormatList.CSV);

/**
 * 選択市区町村状態
 */
const selectedAreaName = ref("");

/**
 * watch:コンポーネント開閉状態を監視
 * 開閉状態に合わせて、開始/終了処理
 */
watch(
  () => props.isOpen,
  () => {
    if (props.isOpen) {
      props.geoMap.exportAreaSelectInteraction.start((address: string) => {
        selectedAreaName.value = address;
      });
    } else {
      props.geoMap.exportAreaSelectInteraction.end();
      emit("endExportArea");
    }
  }
);

/**
 * 交通量データチェック状態
 */
const isTraVosData = ref(false)
/**
 * ODチェック状態
 */
const isOdData = ref(false)
/**
 * 出力ファイルの日付
 */
let exportFileDate:null|string = null;
/**
 * watch:サイドメニューのチェック状態を監視
 */
watch(
  () => [props.zoomLevel, props.sideMenuState],
  async() => {
    isTraVosData.value = props.geoMap.getLayerFactory().TraVos.isVisibleLayer(props.geoMap._map);
    isOdData.value = props.geoMap.getLayerFactory().ODDepartureAndArrival.isVisibleLayer(props.geoMap._map) || props.geoMap.getLayerFactory().ODZone.isVisibleLayer(props.geoMap._map) || props.geoMap.getLayerFactory().ODNode.isVisibleLayer(props.geoMap._map);
  },
  {deep: true}
);
/**
 * 選択市区町村クリア処理
 */
const onClearClick = () => {
  selectedAreaName.value = "";
  props.geoMap.exportAreaSelectInteraction.clear();
};

/**
 * 出力属性データを取得
 */
const getExportData = async () => {
  let exportDataList = null;
  try {
    exportDataList = await props.geoMap.exportArea.export(
      props.geoMap.exportAreaSelectInteraction.selectedExportAreaFeature,
      exportFormat.value
    );
    return exportDataList;
  } catch (err) {
    if (err instanceof ServerError) {
      props.commonView._messageLogic.onOpenMessage(
        MessageDefine.E0001.getMessage([err._url, err._status])
      );
    } else if (err instanceof UnexportableLayerError) {
      props.commonView._messageLogic.onOpenMessage(
        MessageDefine.W0020.getMessage()
      );
    } else {
      props.commonView._messageLogic.onOpenMessage(
        MessageDefine.E0002.getMessage(["市区町村属性取得時エラー"])
      );
    }
    throw err;
  }
};

/**
 * 選択市区町村内データ出力処理
 */
const onExportClick = async (): Promise<void> => {
  props.commonView._loadingLogic.onOpenLoading();
  exportFileDate = ExportUtil.exportFileDate();
  try {
    if (!exportFormat.value || !selectedAreaName.value) return;
    await getExportData()
      .then((exportDataList) => {
        if(exportDataList.length==0){
          props.commonView._messageLogic.onOpenMessage(
              MessageDefine.W0016.getMessage()
            );
          return;
        }

        exportDataList.forEach(dataList => {
          let blob: Blob = null;
          let title = "";
          if (exportFormat.value === ExportFormatList.CSV) {
            const attributeValues = dataList.map(
              (data) => data.attributeValues
            );
            const csv = ExportUtil.toCsvFormat(attributeValues);
            // バイトオーダーマーク：文字コードの判別（UTF-8）
            const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
            blob = new Blob([bom, csv]);
            title = dataList[0].csvFileName;
          } else if (exportFormat.value === ExportFormatList.GeoJSON) {
            const features: Feature[] = dataList.map(
              (data) => data.feature
            );
            const attributeValues = dataList.map(
              (data) => data.attributeValues
            );
            const exportingGeoJSON = ExportUtil.toJsonFormat(
              features,
              attributeValues
            );
            // GeoJSONデータをBlobとして作成
            blob = new Blob([exportingGeoJSON]);
            title = dataList[0].jsonFileName;
          }
          // Blobデータをファイルとして自動ダウンロード
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = title.replace("yyyyMMdd_HHmmss", exportFileDate);
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        });
        props.commonView._messageLogic.onOpenMessage(
            MessageDefine.I0004.getMessage()
        );
      })
      .catch(() => {
        return;
      });
  } finally {
    exportFileDate = null;
    props.commonView._loadingLogic.onCloseLoading();
  }
};

/**
 * 選択市区町村更新処理
 */
const onExportFormatUpdate = (value: string) => {
  exportFormat.value = ExportFormatList[value as keyof typeof ExportFormatList];
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(FormUnit), {
      column: ['36px', '160px', '50px'],
      "gap-row": "15px"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(FormUnitCell), { size: "m" }, {
          default: _withCtx(() => [
            _createTextVNode("属性出力対象は、選択した市区町村内で地図画面上に表示されている情報のみとなります。")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(FormUnit), {
      modifires: "check-items-row",
      column: ['36px', '160px', '50px'],
      "gap-row": "15px"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(FormUnitRow), null, {
          default: _withCtx(() => [
            _createVNode(_unref(FormUnitCell), { size: "m" }, {
              default: _withCtx(() => [
                _createTextVNode("1.市区町村を選択 ")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(FormUnit), {
      modifires: "check-items-row",
      column: ['36px', '160px', '50px'],
      "gap-row": "15px"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(FormUnitCell), null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(selectedAreaName.value
          ? selectedAreaName.value
          : "地図上から市区町村を選択してください"), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(FormUnit), {
      modifires: "check-items-row",
      column: ['36px', '160px', '50px'],
      "gap-row": "15px"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(FormUnitCell), null, {
          default: _withCtx(() => [
            _createVNode(_unref(ButtonItem), {
              onClick: onClearClick,
              disabled: !selectedAreaName.value,
              negative: true
            }, {
              default: _withCtx(() => [
                _createTextVNode("クリア")
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(FormUnit), {
      modifires: "check-items-row",
      column: ['36px', '160px', '50px'],
      "gap-row": "15px"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(FormUnitRow), null, {
          default: _withCtx(() => [
            _createVNode(_unref(FormUnitCell), null, {
              default: _withCtx(() => [
                _createTextVNode(" 2.出力形式を選択※ ")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(FormUnit), {
      modifires: "check-items-row",
      column: ['36px', '160px', '50px'],
      "gap-row": "15px"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(FormUnitRow), null, {
          default: _withCtx(() => [
            _createVNode(_unref(FormUnitCell), null, {
              default: _withCtx(() => [
                _createVNode(_unref(RadioItem), {
                  label: "CSV",
                  name: "exportFormat",
                  disabled: !selectedAreaName.value,
                  value: ExportFormatList.CSV,
                  checked: exportFormat.value === ExportFormatList.CSV,
                  onUpdate: onExportFormatUpdate
                }, null, 8, ["disabled", "value", "checked"])
              ]),
              _: 1
            }),
            _createVNode(_unref(FormUnitCell), null, {
              default: _withCtx(() => [
                _createVNode(_unref(RadioItem), {
                  label: "GeoJSON",
                  name: "exportFormat",
                  disabled: !selectedAreaName.value,
                  value: ExportFormatList.GeoJSON,
                  checked: exportFormat.value === ExportFormatList.GeoJSON,
                  onUpdate: onExportFormatUpdate
                }, null, 8, ["disabled", "value", "checked"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(FormUnit), {
      modifires: "check-items-row",
      column: ['36px', '160px', '50px'],
      "gap-row": "15px"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(FormUnitCell), null, {
          default: _withCtx(() => [
            _createTextVNode(" 3.出力データ"),
            _hoisted_1,
            _createTextVNode(" " + _toDisplayString(!isTraVosData.value && !isOdData.value ?"-": null) + " " + _toDisplayString(isTraVosData.value ? "交通量データ": null) + " " + _toDisplayString(isTraVosData.value && isOdData.value ?"、": null) + " " + _toDisplayString(isOdData.value ? "OD":null), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(ButtonContainer), { align: "right" }, {
      default: _withCtx(() => [
        _createVNode(_unref(ButtonItem), {
          onClick: onExportClick,
          disabled: !selectedAreaName.value
        }, {
          default: _withCtx(() => [
            _createTextVNode("出力")
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    }),
    _hoisted_2,
    _createTextVNode(" ※市区町村属性出力において、以下のデータのみが出力の対象となります。"),
    _hoisted_3,
    _createTextVNode(" 交通量データ、OD ")
  ], 64))
}
}

})